module.exports = __webpack_public_path__ + "img/meetings.2c282df7.svg";